var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.noFilterResults || _vm.noSearchResults)?_c('section',{staticClass:"empty-results"},[_c('span',{staticClass:"empty-results-header"},[_vm._v(_vm._s(_vm.header))]),_c('span',{staticClass:"empty-results-description"},[_vm._v(_vm._s(_vm.description))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }